import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
} from 'react-admin';

// ---------- LIST ----------
export const WalletList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="username" />
      <NumberField source="demo_balance" />
      <TextField source="referral_code" />
      <BooleanField source="is_first_deposit_done" />
      <TextField source="nickname" />
      <TextField source="avatar_url" />
      <TextField source="unique_id" />
      <NumberField source="withdraw_limit_total" />
      <NumberField source="withdraw_used_amount" />
      <TextField source="block_reason" />
      <NumberField source="user" />
      <NumberField source="referred_by" />
    </Datagrid>
  </List>
);

// ---------- EDIT ----------
export const WalletEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="username" />
      <NumberInput source="demo_balance" />
      <TextInput source="referral_code" />
      <BooleanInput source="is_first_deposit_done" />
      <TextInput source="nickname" />
      <TextInput source="avatar_url" />
      <TextInput source="unique_id" />
      <NumberInput source="withdraw_limit_total" />
      <NumberInput source="withdraw_used_amount" />
      <TextInput source="block_reason" />
      <NumberInput source="user" />
      <NumberInput source="referred_by" />
    </SimpleForm>
  </Edit>
);

// ---------- CREATE ----------
export const WalletCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="username" />
      <NumberInput source="demo_balance" />
      <TextInput source="referral_code" />
      <BooleanInput source="is_first_deposit_done" />
      <TextInput source="nickname" />
      <TextInput source="avatar_url" />
      <TextInput source="unique_id" />
      <NumberInput source="withdraw_limit_total" />
      <NumberInput source="withdraw_used_amount" />
      <TextInput source="block_reason" />
      <NumberInput source="user" />
      <NumberInput source="referred_by" />
    </SimpleForm>
  </Create>
);